import './BlogPage.css';

import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArticleImage from '../../assets/articl image.png';
import { BlogCard } from './BlogCard';
import BlogCardImg from '../../assets/AI_Roundup_Nov_social_share.width-800.format-webp 2.png';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid2';
import ReactMarkdown from 'react-markdown';
import ShareDialog from './ShareDialog';
import ShareIcon from '@mui/icons-material/Share';
import { getBlog } from '../../services/blogsApi';
import { logger } from '../../utils/logger';

export const BlogPage = (props) => {
	const navigate = useNavigate();
	const [blog, setBlog] = useState({});
	const [listOfBlogs, setListOfBlogs] = useState([]);
	const [shareModal, setShareModal] = useState(false);
	const { id } = useParams();

	const handleClick = (id) => {
		logger.log('Clicked');
		navigate(`/blogs/${id}`); // Replace '/other-component' with the desired path
	};
	// let listOfBlogs = [
	// 	{
	// 		id: 1,
	// 		title: "",
	// 		description:
	// 			"Lorem ipsum dolor sit amet consectetur. Quis tristique purus amet ipsum nibh. Ornare pellentesque proin enim eu elementum dui dignissim nulla eu. Placerat sed enim et nunc. Vitae feugiat adipiscing congue non habitasse",
	// 		image: BlogCardImg,
	// 	},
	// 	{
	// 		id: 2,
	// 		title: "",
	// 		description:
	// 			"Lorem ipsum dolor sit amet consectetur. Quis tristique purus amet ipsum nibh. Ornare pellentesque proin enim eu elementum dui dignissim nulla eu. Placerat sed enim et nunc. Vitae feugiat adipiscing congue non habitasse",
	// 		image: BlogCardImg,
	// 	},
	// 	{
	// 		id: 3,
	// 		title: "",
	// 		description:
	// 			"Lorem ipsum dolor sit amet consectetur. Quis tristique purus amet ipsum nibh. Ornare pellentesque proin enim eu elementum dui dignissim nulla eu. Placerat sed enim et nunc. Vitae feugiat adipiscing congue non habitasse",
	// 		image: BlogCardImg,
	// 	},
	// ];
	useEffect(() => {
		const fetchBlog = async () => {
			const response = await getBlog(id);
			setBlog(response?.data?.blog);
			setListOfBlogs(response?.data?.relatedBlogs);
		};

		fetchBlog();
	}, [id]);

	// 	let title = props?.title;
	// 	let date = props?.date;
	// 	let subTitle = props?.subTitle;
	// 	let content =
	// 		props?.content ||
	// 		`Lorem ipsum dolor sit amet consectetur. Enim faucibus dui habitasse sed ut facilisi volutpat arcu. Mauris nunc venenatis sapien lorem enim aliquam duis mauris tristique. Augue diam vel elit non et nec augue id mi. Facilisi mattis scelerisque sem consectetur mattis nec tellus. Netus a sodales eget cursus nulla. Vitae at at pulvinar egestas nec sit consequat. Aliquam quis eget vulputate aliquam nec nunc nulla pellentesque duis. Pharetra sed porta luctus duis commodo nullam dapibus eget. Purus viverra cursus viverra tempus amet suscipit urna. Fermentum fringilla pretium odio odio. Sed elit in massa integer enim est cras nisl nibh.\n\n
	// Porttitor viverra elementum tincidunt et lacus dui. Nulla vulputate quis est etiam lectus cum gravida arcu. Elementum at bibendum sollicitudin condimentum arcu ipsum. Consectetur ut scelerisque arcu fames in mattis aliquam at. Euismod arcu id purus scelerisque semper nunc cras. Ullamcorper nam leo lectus magna nibh. Viverra in nulla egestas ipsum cras justo erat. In odio in quis turpis risus. Suspendisse pellentesque lacinia interdum ut turpis nulla duis. Euismod ut odio nulla laoreet felis faucibus ornare. A enim risus magna commodo sagittis sed egestas. Eu ut mauris sit eget sapien pharetra semper tempus molestie. Feugiat pellentesque vel pretium nec adipiscing.\n\n
	// Aenean tellus tellus morbi odio a enim. Risus cum enim vitae libero. Iaculis vitae gravida dignissim pellentesque nulla. Mauris tristique sapien netus feugiat adipiscing erat. Porttitor auctor sed malesuada turpis a nulla. Tellus facilisis massa elit vitae a in in nunc lectus. Erat ipsum semper massa in. Consequat in nunc a elementum mauris massa sit convallis sed. Viverra rhoncus vehicula venenatis morbi viverra urna ut in rhoncus. Quam elit adipiscing in pellentesque mauris aliquam blandit.\n\n
	// Quam posuere et in tellus magna vestibulum vestibulum. Lacus posuere risus laoreet duis nullam est ipsum. Dapibus vitae eget tellus tempus dignissim vulputate ut. Scelerisque at vel feugiat pharetra commodo magna etiam at arcu. Sit arcu risus leo sed suspendisse rhoncus et vehicula. Dolor porta sed sagittis vestibulum fermentum ac porttitor morbi turpis. Dolor nibh orci fringilla sed viverra semper convallis. Tortor tincidunt at in proin tempor. Mi etiam non massa vulputate lorem enim vitae donec.\n\n
	// Egestas velit sodales lorem viverra massa natoque nunc purus lorem. Egestas eu porta malesuada nec quam duis lacus bibendum eget. Rutrum ac faucibus commodo viverra commodo sed. Molestie pellentesque auctor lectus sapien nec. Risus auctor at massa ultrices neque nunc. Amet justo eu tristique dictum id dolor. Congue nisl duis sed fames tellus pellentesque lacus velit odio.\n\n
	// Faucibus habitant molestie turpis purus consequat hendrerit nunc arcu. Fringilla viverra nunc elementum sit id ipsum ut aliquet. Porta donec egestas ac sed. Sed fermentum in dui sollicitudin lacus hac pellentesque senectus tellus. Aliquam elit at leo turpis placerat. Lectus aenean nec nunc bibendum id vitae malesuada id magna. Diam mauris faucibus faucibus tortor. Fermentum dictumst feugiat a amet. Malesuada non in nulla sapien tortor. Ridiculus lorem tortor sit massa tristique lectus. Eget nec sem aliquam adipiscing tellus lectus natoque quisque. Fermentum ultrices elit velit amet nisl sagittis metus mauris rhoncus.\n\n
	// Massa etiam rhoncus morbi quis ipsum augue eget cras odio. Risus mattis nam aliquam ut tellus adipiscing habitant ornare turpis. Sed interdum viverra in maecenas vitae sapien placerat. In nunc libero tincidunt quis gravida in est. Integer libero nec diam et sociis. Bibendum diam pharetra adipiscing mauris aliquam viverra volutpat in sollicitudin.\n\n
	// In at euismod ut augue risus a lacus metus suscipit. At hac egestas ut tincidunt. Orci phasellus purus tortor aliquam libero eu feugiat at vel. Duis tellus morbi ullamcorper lacus porttitor nunc. Ultrices ac in id ac eu at sed id auctor. Gravida volutpat sed morbi eget aliquam suspendisse. Tincidunt diam massa ac fames aliquet feugiat. At montes potenti elit cursus. Ut felis eleifend neque vitae. Quam orci tellus blandit est eu. Elit id mattis morbi non laoreet metus. Sed sit et amet pretium ipsum lobortis porta. Nunc tempus fermentum massa varius at dui sit nibh. Elit pharetra volutpat nec viverra varius amet. Sed ornare sit amet et.\n\n
	// Et blandit diam nulla lorem augue. Accumsan eget eget dictum tempor mi fermentum interdum. Faucibus eleifend pellentesque pharetra ac. Quis vel in risus massa eu. Massa amet sodales mi pretium vel neque. Dignissim pellentesque sit vel a elementum quam iaculis imperdiet. Nunc arcu sit purus ligula non varius. Bibendum consequat et nulla massa sagittis purus sed. Enim nunc sit dolor iaculis nec dui quam aliquam viverra. Nec venenatis porttitor pharetra viverra porta. Neque pulvinar malesuada ac aenean semper. Sodales amet potenti et urna. Augue at turpis ut egestas egestas amet. Dui nec rhoncus tincidunt enim dolor a.\n\n`;

	return (
		<>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					margin: '2.5rem 2rem 3rem',
					alignItems: 'start',
				}}
			>
				{/* Article header */}
				<Box sx={{ paddingX: { xs: '0', md: '6.25rem' } }}>
					<Box
						sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
						onClick={() => {
							navigate(-1);
						}}
					>
						<ArrowBackIosIcon /> Back
					</Box>
					<Typography variant="h2" gutterBottom sx={{ color: '#202124' }}>
						{blog?.Blog_Title}
					</Typography>
				</Box>
				{/* Article sub header */}
				<Box
					sx={{
						paddingX: { xs: '0', md: '6.25rem' },
						display: 'flex',
						flexDirection: 'row',
					}}
				>
					<Typography
						variant="caption"
						gutterBottom
						sx={{ whiteSpace: 'nowrap', marginRight: '1.25rem ' }}
					>
						{blog?.createdOn}
					</Typography>
					<Typography
						variant="body"
						gutterBottom
						sx={{
							borderLeft: '1px solid #202124',
							width: '75%',
							textAlign: 'start',
							paddingX: '0.5rem',
						}}
					>
						{blog?.subTitle}
					</Typography>
				</Box>
				<Box
					onClick={() => setShareModal(true)}
					sx={{
						paddingX: { xs: '0', md: '6.25rem' },
						paddingY: '0.75',
						display: 'flex',
						alignItems: 'center',
						marginLeft: 'auto',
						cursor: 'pointer',
					}}
				>
					<ShareIcon /> Share
				</Box>
				<ShareDialog open={shareModal} handleClose={() => setShareModal(false)} />
			</Box>
			<Box sx={{ display: 'flex', justifyContent: 'center' }}>
				<img src={blog?.image} alt="Article" width={'90%'} />
			</Box>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					marginX: { xs: '1rem', md: '2rem' },
					alignItems: 'start',
					textAlign: 'start',
				}}
			>
				{/* <Typography sx={{ paddingX: "10rem" }}>
					{blog?.content
						?.replace(/\\n/g, "\n")
						.split("\n\n")
						.map((paragraph, index) => (
							<p key={index}>{paragraph}</p>
						))}
				</Typography> */}
				<Typography className="blogContent" sx={{ paddingX: { xs: '2rem', md: '10rem' } }}>
					<ReactMarkdown>{blog?.content?.replace(/\\n/g, '\n')}</ReactMarkdown>
				</Typography>
			</Box>
			{listOfBlogs?.length > 0 && (
				<Box
					sx={{
						marginY: '1rem',
						marginX: '3rem',
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					<Typography variant="h3" sx={{ marginX: { xs: '0', md: '7rem' } }}>
						Related Articles
					</Typography>
					<Box
						sx={{
							paddingY: '1rem',
							paddingX: '2rem',
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'center',
						}}
					>
						{listOfBlogs?.map((item) => (
							<Grid
								key={item.id}
								size={4}
								display="flex"
								justifyContent="center"
								alignItems="center"
							>
								<div
									onClick={() => handleClick(item.id)}
									style={{ cursor: 'pointer' }}
								>
									<BlogCard
										type="Bottom"
										title={item?.Blog_Title}
										description={item?.description}
										image={item?.image}
									/>
								</div>
							</Grid>
						))}
					</Box>
				</Box>
			)}
		</>
	);
};
